"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrAutocompleteComboboxProvider = void 0;
const react_1 = __importDefault(require("react"));
const fdr_regular_fusion_fdr_autocomplete_context_1 = require("@hotelplan/fdr.regular.fusion.fdr-autocomplete-context");
function FdrAutocompleteCombobox(props) {
    const { children, className } = props;
    const { isSuggestionsOpened } = (0, fdr_regular_fusion_fdr_autocomplete_context_1.useFdrAutocompleteContext)();
    return (react_1.default.createElement("div", { "aria-expanded": isSuggestionsOpened, className: `multiple-autocomplete ${className ? className : ''}`, "data-id": "multiple-autocomplete" }, children));
}
function FdrAutocompleteComboboxProvider(props) {
    const { className, children } = props, providerProps = __rest(props, ["className", "children"]);
    return (react_1.default.createElement(fdr_regular_fusion_fdr_autocomplete_context_1.FdrAutocompleteProvider, Object.assign({}, providerProps),
        react_1.default.createElement(FdrAutocompleteCombobox, { className: className }, children)));
}
exports.FdrAutocompleteComboboxProvider = FdrAutocompleteComboboxProvider;
//# sourceMappingURL=fdr-combobox.provider.js.map